<template>
  <div>
    <cover :topImg="topImg"/>
    <div class="type-center">
      <div class="publicTitle mt60">
        <div class="">客户案列</div>
        <div class="publicTitle-text">Customer Case</div>
        <div class="publicTitle-line"/>
      </div>
      <div class="customerCase">
        <div class="customerCase-text ml40" v-if="configs.al_descr">
          {{ $i18n.locale == 'zh' ? configs.al_descr.zhVal : configs.al_descr.enVal }}
        </div>
        <!--https://www.w3schools.com/html/mov_bbb.mp4-->
        <video
            class="customerCase-video"
            :poster="$i18n.locale == 'zh' ? configs.al_rt_thumb_img.zhVal : configs.al_rt_thumb_img.enVal"
            :src="$i18n.locale == 'zh' ? configs.al_rt_video.zhVal : configs.al_rt_video.enVal"
            controls="controls">
        </video>
        <div class="bg2661D8 flex ju-sp customerCase-More white-color">
          <a class="white-color" :href="$i18n.locale == 'zh' ? configs.al_linkto.zhVal : configs.al_linkto.enVal"
             target="_blank">
            {{ $t('了解更多') }} > >
          </a>
          <div style="width: 167px; height: 8px; background: #FFFFFF;"/>
        </div>
      </div>
    </div>
    <div class="customerCase-aboutUs mtb30">
      <img class="customerCase-aboutUs-bg" src="@/assets/image/home/aboutUs.png"/>
      <div class="type-center flex al-cn">
        <img
            class="customerCase-aboutUs-img flex-shrink-0"
            :src="$i18n.locale == 'zh' ? configs.al_lb_img.zhVal : configs.al_lb_img.enVal"/>
        <div class="mt15 mr40 ml60">
          <div class="mb50 pb40 cl053EB2 f32 fB400" v-if="configs.al_rb_title">
            {{ $i18n.locale == 'zh' ? configs.al_rb_title.zhVal : configs.al_rb_title.enVal }}
          </div>
          <div class="line-clamp10 mb30 cl46494D f20" v-if="configs.al_rb_descr">
            {{ $i18n.locale == 'zh' ? configs.al_rb_descr.zhVal : configs.al_rb_descr.enVal }}
          </div>
          <div class="bg053EB2" style="height: 8px;width: 167px"/>
        </div>
      </div>
    </div>
    <div class="type-center classicCase">
      <div class="publicTitle mt60">
        <div class="">经典案例</div>
        <div class="publicTitle-text">Classic Case</div>
        <div class="publicTitle-line"/>
      </div>
      <div class="mt30 video-container" v-for="(item,index) in classicCasesList" :key="index">
        <video
            class="classicCase-video"
            :poster="$i18n.locale == 'zh' ? item.img : item.imgEn"
            :src="$i18n.locale == 'zh' ? item.video : item.videoEn"
            :controls="playingStates[index]"
            :ref="`video_${index}`">
        </video>
        <!-- 将控制层放在video外部 -->
        <div class="video-overlay" @click="togglePlay(index)">
          <div class="custom-play-button" v-show="!playingStates[index]">
            <div class="play-icon"/>
          </div>
          <!--<div class="custom-pause-button" v-show="playingStates[index]">
            <div class="pause-icon"></div>
          </div>-->
        </div>
        <div class="classicCase-title" v-if="!playingStates[index]">
          {{ $i18n.locale == 'zh' ? item.title : item.titleEn }}
        </div>
      </div>
    </div>
    <div class="type-center">
      <div class="publicTitle mt60 mb30">
        <div class="">典型应用场景</div>
        <div class="publicTitle-text">Typical Applications</div>
        <div class="publicTitle-line"/>
      </div>
      <div style="position: relative;">
        <div class="ml40 mr50">
          <swiper id="swiperBox" class="swiper-wrapper" :options="swiperOption" ref="mySwiper">
            <swiper-slide
                class="swiper-slide mlr10"
                v-for="(item,index) in typicalApplications"
                :key="index">
              <img style="width: 100%;" :src="$i18n.locale == 'zh' ? item.img : item.imgEn"/>
              <div class="swiper-title">{{ $i18n.locale == 'zh' ? item.title : item.titleEn }}</div>
            </swiper-slide>
            <!-- Optional controls -->
            <!--<div class="swiper-pagination" slot="pagination"></div>-->
            <!--<div class="swiper-scrollbar" slot="scrollbar"></div>-->
          </swiper>
        </div>
        <div class="swiper-button-prev" slot="button-prev"/>
        <div class="swiper-button-next" slot="button-next"/>
      </div>
    </div>
  </div>
</template>
<script>
import {getClassicCases, getConfigs, getTypicalApplications} from "@/api/api";
import {swiper, swiperSlide} from "vue-awesome-swiper";

export default {
  name: "",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      topImg: require('@/assets/image/customerCaseTop.png'),
      configs: {},
      classicCasesList: [],
      typicalApplications: [],
      playingStates: [], // 存储每个视频的播放状态
      swiperOption: {
        slidesPerView: 3, // 设置每张图片显示的个数
        spaceBetween: 20, // 设置每张图片之间的间隔
        autoplay: false,
       /* autoplay: {
          delay: 3000, // 自动播放的间隔时间
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        },*/
        loop: false, // 是否循环播放
        // 分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 导航按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        grabCursor: true, // 设置鼠标拖动时，鼠标样式为小手
        // 响应式设置
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          }
        }
      }
    };
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.getConfigs();
    this.getClassicCases();
    this.getTypicalApplications();
  },
  methods: {
    // 切换视频播放状态
    togglePlay(index) {
      try {
        const videoRef = this.$refs[`video_${index}`];
        if (!videoRef || !videoRef[0]) return;

        const video = videoRef[0];
        const currentState = this.playingStates[index] || false;

        if (!currentState) {
          // 开始播放
          video.play().then(() => {
            this.$set(this.playingStates, index, true);
          }).catch(e => {
            console.error('Video play failed:', e);
          });
        } else {
          // 暂停播放
          video.pause();
          this.$set(this.playingStates, index, false);
        }

        // 监听视频结束事件，结束后恢复到初始状态
        video.onended = () => {
          this.$set(this.playingStates, index, false);
        };
      } catch (e) {
        console.error('Error toggling video play state:', e);
      }
    },
    //典型应用场景
    getTypicalApplications() {
      getTypicalApplications().then(res => {
        if (res.code == 1) {
          this.typicalApplications = res.data;
        }
      })
    },
    //经典案例
    getClassicCases() {
      getClassicCases().then(res => {
        if (res.code == 1) {
          this.classicCasesList = res.data;
        }
      }).catch(err => {
        this.loading = false;
      });
    },
    //配置信息
    getConfigs() {
      getConfigs().then(res => {
        if (res.code == 1) {
          this.configs = res.data;
          this.$store.commit('setConfigs', res.data)
        }
      }).catch(err => {
      });
    },
  },

}
</script>
<style scoped lang="scss">
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
  box-sizing: content-box;

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.swiper-title {
  position: absolute;
  left: 0;
  bottom: 54px;
  width: 110px;
  //height: 26px;
  //line-height: 26px;
  padding: 5px;
  background: #DFA51F;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  border-radius: 0px 4px 4px 0px;
}

.customerCase {
  position: relative;

  &-video {
    position: absolute;
    top: 0;
    right: 0;
    width: 907px;
    height: 554px;
  }

  &-text {
    padding-top: 86px;
    width: 144px;
    height: 438px;
  }

  &-More {
    padding: 92px 43px 47px 61px;
  }

  &-aboutUs {
    position: relative;

    &-bg {
      position: absolute;
      top: 58px;
      right: 100px;
      width: 740px;
      //height: 177px;
    }

    &-img {
      width: 686px;
      height: 538px;
    }
  }
}

.classicCase {
  position: relative;

  &-video {
    width: 100%;
    height: 473px;
    object-fit: cover;
  }

  .video-container {
    position: relative;

    .video-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  // 自定义播放按钮
  .custom-play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
  }

  .play-icon {
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 25px solid #fff;
    margin-left: 5px;
  }

  // 自定义暂停按钮
  .custom-pause-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity 0.3s ease;
  }

  .pause-icon {
    width: 25px;
    height: 25px;
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 8px;
      height: 25px;
      background: #fff;
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  &-title {
    position: absolute;
    left: 20px;
    bottom: 20px;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
  }
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  line-height: 35px;
  background: rgba(216, 216, 216, 0.72);
  border-radius: 10%;
  display: flex;
  justify-content: center;
  //align-items: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-weight: bold;
  font-size: 30px;
  color: #063FB3E5;

  &:hover {
    color: #fff;
    background: rgba(6, 63, 179, 0.9);
    transform: translateY(-50%) scale(1.1);
  }
}

.swiper-button-prev {
  left: 0;

  &::after {
    content: '‹';
  }
}

.swiper-button-next {
  right: 0;

  &::after {
    content: '›';
  }
}
</style>
